<template>
    <div style="width: 100%">
        <div class="col-sm-12">
            <div class="alert alert-info" v-if="!is_expirated">Un code de validation a été envoyé sur votre adresse email.  Le code expirera dans : <b>{{ countdown }}</b></div>
            <div class="alert alert-danger" v-if="is_expirated">Le code de validation a expiré.</div>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'ChronoComponent',
    props: ['end'],
    data() {
        return {
            formatedEnd: null,
            countdown: null,
            interval: null,
            is_expirated: false,
        } 
    } ,
    methods: {
         startCountdown() {
            const updateCountdown = () => {
                const now = this.moment();
                const distance = this.moment(this.formatedEnd).diff(now);

                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                this.countdown = minutes + "min et " + seconds + "s ";

                if (distance < 0) {
                    this.is_expirated = true;
                    clearInterval(this.interval);
                    $('#validCode').prop("disabled",true);
                    $('#generateNewCode').css('display', 'inline-block');
                    
                }
            };

            updateCountdown();
            this.interval = setInterval(updateCountdown, 1000);
        }
    }, 
    beforeDestroy() {
        if(this.is_expirated)
            clearInterval(this.interval);
    },
    mounted(){
        this.formatedEnd = this.end ? this.moment(this.end) : this.moment().add(10 , 'm');
        this.startCountdown();
    },
}
</script>